export default "__VITE_ASSET__cxpzM5sU__"